import React from 'react';

import { CompanyLogoBadge } from '../../../../CompanyLogoBadge';
import styles from './CompanyNameCellRenderer.module.scss';

/**
 * Table-cell adapter for the shared CompanyLogoBadge. Uses only what the row
 * already provides (`logo`/`websiteUrl`) — rows without either show the
 * first-letter badge; no per-row fetches.
 */
export const CellCompanyLogo: React.FC<{ row: any; name?: string }> = ({ row, name }) => {
    return (
        <CompanyLogoBadge
            name={name ?? row?.orgName ?? row?.borrowerName}
            logo={row?.logo}
            websiteUrl={row?.websiteUrl}
            size={24}
            shape="square"
            className={styles.CellLogoRadius}
        />
    );
};

export default CellCompanyLogo;
